const es = {
  brand: "E2 Care",
  tagline: "Cuidados tranquilos y conectados.",
  nav_dashboard: "Panel",
  nav_residents: "Pacientes",
  nav_patients: "Pacientes",
  nav_rooms: "Habitaciones",
  nav_devices: "Dispositivos",
  nav_events: "Eventos",
  nav_alerts: "Alertas",
  nav_users: "Equipo",
  nav_settings: "Ajustes",
  nav_admin: "Administración",
  nav_signout: "Cerrar sesión",
  topbar_search_placeholder: "Buscar pacientes, habitaciones, dispositivos…",
  admin_super_only: "Solo los superadministradores pueden gestionar organizaciones.",
  admin_admin_only: "Solo los administradores pueden acceder a esta página.",
  admin_tab_orgs: "Organizaciones",
  admin_tab_users: "Usuarios",
  admin_tab_patients: "Pacientes",
  admin_tab_rooms: "Habitaciones",
  admin_tab_buildings: "Edificios",
  admin_tab_devices: "Dispositivos",
  admin_tab_alerts: "Alertas",
  admin_tab_qa: "Herramientas de prueba",
  admin_delete: "Eliminar",
  admin_no_orgs_yet: "Aún no hay organizaciones.",
  admin_field_name: "Nombre",
  admin_field_email: "Correo electrónico",
  admin_field_phone: "Teléfono",
  admin_field_password: "Contraseña",
  admin_field_role: "Rol",
  admin_field_type: "Tipo",
  admin_field_timezone: "Zona horaria",
  admin_field_address: "Dirección",
  admin_field_status: "Estado",
  admin_field_organization: "Organización",
  admin_password_keep: "Dejar vacío para conservar",
  admin_field_birth_date: "Fecha de nacimiento",
  admin_field_room: "Habitación",
  admin_field_room_none: "Sin asignar",
  admin_field_photo: "URL de la foto",
  admin_field_photo_hint: "Pegue una URL pública — la carga completa llegará en v2.",
  admin_field_notes: "Notas del cuidador",
  admin_field_emergency_contact: "Contacto principal de emergencia",
  admin_field_ec_name: "Nombre",
  admin_field_ec_phone: "Teléfono",
  admin_field_ec_relationship: "Parentesco",
  admin_field_mac: "Dirección MAC",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Asignado a",
  admin_field_assigned_room: "Habitación asignada",
  admin_field_assigned_patient: "Paciente asignado",
  admin_field_assigned_hint: "Opcional. Sensores → habitación; pulseras → paciente.",
  admin_field_sensor_target: "Montado en",
  admin_field_sensor_target_hint: "Indica al sistema si este sensor vigila una puerta o una ventana.",
  sensor_target_door: "Puerta",
  sensor_target_window: "Ventana",
  sensor_target_unset: "Sin configurar",
  admin_field_sensor_label: "Etiqueta del sensor",
  admin_field_sensor_label_hint: "Nombre descriptivo mostrado en alertas y eventos — p. ej. «Puerta principal», «Ventana del baño».",
  admin_field_building: "Edificio",
  admin_field_building_required: "Una habitación debe pertenecer a un edificio.",
  room_openings: "Aberturas",
  room_no_openings: "Aún no hay sensores de puerta o ventana instalados en esta habitación.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Último cambio",
  admin_field_description: "Descripción",
  admin_field_severity: "Gravedad",
  admin_field_patient: "Paciente",
  admin_field_device: "Dispositivo",
  admin_field_message: "Mensaje",
  admin_orgs_title: "Organizaciones",
  admin_orgs_sub: "Crear, editar y archivar inquilinos de E2 Care.",
  admin_orgs_count: "organizaciones",
  admin_org_new: "Nueva organización",
  admin_org_new_title: "Nueva organización",
  admin_org_edit_title: "Editar organización",
  admin_org_created: "Organización creada.",
  admin_org_updated: "Organización actualizada.",
  admin_org_deleted: "Organización archivada.",
  admin_org_delete_title: "¿Archivar organización?",
  admin_org_delete_confirm: "«{name}» se ocultará de los listados.",
  admin_users_title: "Usuarios",
  admin_users_sub_super: "Gestionar todas las cuentas de usuario en todos los inquilinos.",
  admin_users_sub_org: "Gestionar cuentas de usuario de {org}.",
  admin_user_new: "Nuevo usuario",
  admin_user_new_title: "Nuevo usuario",
  admin_user_edit_title: "Editar usuario",
  admin_user_created: "Usuario creado.",
  admin_user_updated: "Usuario actualizado.",
  admin_user_deleted: "Usuario archivado.",
  admin_user_delete_title: "¿Archivar usuario?",
  admin_user_delete_confirm: "«{name}» perderá el acceso.",
  admin_user_memberships: "Membresías de organización",
  admin_patients_title: "Pacientes",
  admin_patients_sub_super: "Gestionar todos los pacientes en todos los inquilinos.",
  admin_patients_sub_org: "Gestionar pacientes en {org}.",
  admin_patient_new: "Nuevo paciente",
  admin_patient_new_title: "Nuevo paciente",
  admin_patient_edit_title: "Editar paciente",
  admin_patient_created: "Paciente creado.",
  admin_patient_updated: "Paciente actualizado.",
  admin_patient_deleted: "Paciente archivado.",
  admin_patient_delete_title: "¿Archivar paciente?",
  admin_patient_delete_confirm: "«{name}» se ocultará de los listados.",
  admin_rooms_title: "Habitaciones",
  admin_rooms_sub_super: "Configurar habitaciones en todos los inquilinos.",
  admin_rooms_sub_org: "Configurar habitaciones en {org}.",
  admin_room_new: "Nueva habitación",
  admin_room_new_title: "Nueva habitación",
  admin_room_edit_title: "Editar habitación",
  admin_room_created: "Habitación creada.",
  admin_room_updated: "Habitación actualizada.",
  admin_room_deleted: "Habitación archivada.",
  admin_room_delete_title: "¿Archivar habitación?",
  admin_room_delete_confirm: "«{name}» se ocultará.",
  admin_devices_title: "Dispositivos",
  admin_devices_sub_super: "Aprovisionar dispositivos Moko en todos los inquilinos.",
  admin_devices_sub_org: "Aprovisionar dispositivos Moko en {org}.",
  admin_device_new: "Nuevo dispositivo",
  admin_device_new_title: "Nuevo dispositivo",
  admin_device_edit_title: "Editar dispositivo",
  admin_device_created: "Dispositivo creado.",
  admin_device_updated: "Dispositivo actualizado.",
  admin_device_deleted: "Dispositivo archivado.",
  admin_device_delete_title: "¿Archivar dispositivo?",
  admin_device_delete_confirm: "El dispositivo {mac} se ocultará.",
  admin_buildings_title: "Edificios",
  admin_buildings_sub_super: "Agrupar habitaciones por edificio / ala en todos los inquilinos.",
  admin_buildings_sub_org: "Agrupar habitaciones por edificio / ala en {org}.",
  admin_building_new: "Nuevo edificio",
  admin_building_new_title: "Nuevo edificio",
  admin_building_edit_title: "Editar edificio",
  admin_building_created: "Edificio creado.",
  admin_building_updated: "Edificio actualizado.",
  admin_building_deleted: "Edificio archivado.",
  admin_building_delete_title: "¿Archivar edificio?",
  admin_building_delete_confirm: "«{name}» se ocultará.",
  admin_qa_title: "Herramientas de prueba",
  admin_qa_sub: "Inyecte eventos / alertas para probar sin hardware Moko real.",
  admin_qa_event_title: "Inyectar evento de prueba",
  admin_qa_event_sub: "Simula un webhook de Moko.",
  admin_qa_alert_title: "Inyectar alerta de prueba",
  admin_qa_alert_sub: "Omite la capa de eventos y escribe una alerta directamente.",
  admin_qa_inject_event: "Inyectar evento",
  admin_qa_inject_alert: "Inyectar alerta",
  admin_qa_event_done: "Evento inyectado.",
  admin_qa_alert_done: "Alerta inyectada.",
  admin_qa_disclaimer: "Estos endpoints deben deshabilitarse en producción.",
  admin_alerts_title: "Política de alertas",
  admin_alerts_sub: "Reglas de alerta para toda {org}. Se aplican a cada paciente de este inquilino.",
  admin_alerts_quiet_title: "Horas de silencio",
  admin_alerts_quiet_desc: "Define cuándo esta organización está en «modo nocturno». Útil para enviar alertas no críticas de forma más discreta.",
  admin_alerts_quiet_hint: "Las horas se interpretan en la zona horaria local de la organización. El rango puede pasar de medianoche (p. ej. 22:00 → 06:00).",
  admin_alerts_night_start: "La noche empieza",
  admin_alerts_night_end: "La noche termina",
  admin_alerts_load_failed: "Cargar política de alertas",
  admin_alerts_save_failed: "Guardar política de alertas",
  admin_alerts_saved: "Política de alertas guardada.",
  admin_alerts_clear_title: "Borrar alertas activas",
  admin_alerts_clear_desc: "Confirma todas las alertas abiertas de esta organización con un clic.",
  admin_alerts_clear_hint: "Útil tras un simulacro planificado o un sensor mal configurado que generó una oleada de falsos positivos. Las alertas confirmadas permanecen en el historial.",
  admin_alerts_ack_all_button: "Confirmar todas",
  admin_alerts_ack_all_title: "¿Confirmar todas las alertas activas?",
  admin_alerts_ack_all_confirm: "Esto marcará como confirmada cada alerta abierta en {org}. Esta acción no se puede deshacer.",
  admin_alerts_ack_all_done: "{count} alerta(s) confirmada(s).",
  admin_alerts_ack_all_done_generic: "Todas las alertas activas confirmadas.",
  admin_alerts_ack_all_failed: "Confirmar todas las alertas",
  org_type_nursing_home: "Residencia de ancianos",
  org_type_assisted_living: "Vida asistida",
  org_type_hospital: "Hospital",
  org_type_home_care: "Cuidados a domicilio",
  role_admin: "Administrador",
  role_caregiver: "Cuidador",
  role_family: "Familia",
  status_active: "activo",
  status_inactive: "inactivo",
  confirm: "Confirmar",
  sign_in: "Iniciar sesión",
  signed_in: "Sesión iniciada",
  sign_up: "Registrarse",
  email: "Correo electrónico",
  password: "Contraseña",
  full_name: "Nombre completo",
  create_account: "Crear cuenta",
  no_account: "¿Aún no tienes cuenta?",
  have_account: "¿Ya tienes una cuenta?",
  login_welcome: "Bienvenido de nuevo",
  login_sub: "Inicia sesión para seguir supervisando a tus residentes.",
  register_welcome: "Únete a E2 Care",
  register_sub: "Crea tu espacio de trabajo en menos de un minuto.",
  total_residents: "Pacientes",
  active_devices: "Dispositivos activos",
  open_alerts: "Alertas abiertas",
  offline_gateways: "Dispositivos fuera de línea",
  falls_7d: "Caídas (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Batería baja",
  critical_residents: "Críticos",
  status_ok: "Todo en orden",
  status_warning: "Atención",
  status_critical: "Crítico",
  status_online: "En línea",
  status_offline: "Fuera de línea",
  search: "Buscar",
  filter: "Filtrar",
  all: "Todos",
  refresh: "Actualizar",
  loading: "Cargando…",
  no_results: "Aún no hay nada aquí.",
  view_profile: "Ver perfil",
  showing_n_of_m: "Mostrando {n} de {m}",
  load_more: "Cargar más",
  auto_refresh: "En vivo · auto-actualizar",
  auto_refresh_paused: "Pausado (cargar más activo)",
  updated_just_now: "Actualizado ahora",
  updated_n_sec_ago: "Actualizado hace {n}s",
  updated_n_min_ago: "Actualizado hace {n}m",
  acknowledge: "Confirmar",
  acknowledged: "Confirmado",
  ack_all: "Confirmar todas",
  ack_all_confirm: "¿Confirmar las {count} alerta(s) activa(s)?",
  ack_all_running: "Confirmando…",
  ack_all_done: "{count} alerta(s) confirmada(s).",
  ack_all_partial: "{ok} confirmada(s) · {fail} fallida(s).",
  last_seen: "Visto por última vez",
  battery: "Batería",
  signal: "Señal",
  firmware: "Firmware",
  room: "Apto / Hab.",
  age: "Edad",
  emergency_contact: "Contacto de emergencia",
  notes: "Notas",
  assigned_devices: "Dispositivos asignados",
  recent_events: "Eventos recientes",
  timeline_24h: "Últimas 24 horas",
  delivery_status: "Estado de entrega",
  acknowledged_by: "Confirmado por",
  dashboard_title: "Visión general",
  dashboard_sub: "Una lectura rápida de todo lo que ocurre en las residencias que atiendes.",
  residents_title: "Pacientes",
  residents_sub: "Personas que estás supervisando ahora.",
  devices_title: "Dispositivos",
  devices_sub: "Sensores y pulseras.",
  devices_sub_admin: "Pasarelas, sensores y pulseras.",
  events_title: "Eventos en vivo",
  events_sub: "Flujo cronológico de cada dispositivo conectado.",
  alerts_title: "Alertas",
  alerts_sub: "Notificaciones escaladas a familia y cuidadores.",
  settings_title: "Ajustes",
  settings_sub: "Tus preferencias y reglas de notificación.",
  users_title: "Equipo",
  users_sub: "Cuidadores, familia y administradores con acceso.",
  falls_chart_title: "Caídas y SOS — últimos 7 días",
  recent_alerts_title: "Alertas críticas recientes",
  no_alerts: "No hay alertas abiertas. Todos están a salvo.",
  event_fall: "Caída detectada",
  event_sos: "Botón SOS pulsado",
  event_door_open: "Puerta abierta",
  event_door_close: "Puerta cerrada",
  event_inactivity: "Inactividad prolongada",
  event_low_battery: "Batería baja",
  event_offline: "Dispositivo fuera de línea",
  event_online: "Dispositivo de nuevo en línea",
  event_heartbeat: "Latido",
  event_button_press: "Botón pulsado",
  device_gateway: "Pasarela Bluetooth",
  device_door_sensor: "Sensor de puerta",
  device_bracelet: "Pulsera",
  device_unknown: "Dispositivo desconocido",
  language: "Idioma",
  notifications: "Notificaciones",
  quiet_hours: "Horas de silencio",
  escalation: "Política de escalado",
  just_now: "ahora mismo",
  rel_prefix: "hace",
  min_ago: "min",
  h_ago: "h",
  d_ago: "d",
  demo_hint: "Cuenta demo: admin@e2care.lv / Care2024!",
  open_menu: "Abrir menú",
  close_menu: "Cerrar menú",
  care_team: "Equipo de cuidados",
  family_members: "Familia",
  no_caregivers: "Aún no hay cuidadores asignados.",
  no_family: "Aún no hay familiares vinculados.",
  add_caregiver: "Añadir cuidador",
  add_family: "Añadir familiar",
  select_user: "Selecciona un usuario…",
  cancel: "Cancelar",
  add: "Añadir",
  remove: "Quitar",
  save: "Guardar",
  relationship: "Parentesco",
  relationship_son: "Hijo",
  relationship_daughter: "Hija",
  relationship_spouse: "Cónyuge",
  relationship_other: "Otro",
  notify_via: "Notificar vía",
  call_contact: "Llamar",
  view_resident: "Abrir perfil",
  address: "Dirección",
  admin_only_section: "Herramientas de admin",
  rooms_title: "Habitaciones",
  rooms_sub: "Cada habitación que supervisas — pacientes, dispositivos y estado actual.",
  room_name: "Habitación",
  room_type: "Tipo",
  room_type_private_room: "Habitación privada",
  room_type_shared_room: "Habitación compartida",
  room_type_apartment: "Apartamento",
  room_type_corridor: "Pasillo",
  room_type_common_area: "Zona común",
  room_floor: "Planta",
  room_state: "Estado actual",
  door: "Puerta",
  window: "Ventana",
  door_open_state: "Abierta",
  door_closed_state: "Cerrada",
  door_unknown_state: "Desconocido",
  room_no_devices: "Aún no hay dispositivos en esta habitación.",
  room_no_patients: "Aún no hay pacientes asignados a esta habitación.",
  room_patients: "Pacientes en la habitación",
  room_devices: "Dispositivos en la habitación",
  room_activity: "Cronología de actividad",
  rooms_filter_all_types: "Todos los tipos",
  widget_active_alerts: "Alertas activas",
  widget_active_alerts_sub: "Críticas, sin resolver y confirmadas",
  widget_patients_status: "Estado de pacientes",
  widget_devices_health: "Salud de dispositivos",
  widget_room_activity: "Actividad de habitaciones",
  widget_recent_events: "Flujo de eventos en vivo",
  widget_connectivity: "Conectividad",
  metric_critical: "Crítico",
  metric_unresolved: "Sin resolver",
  metric_acknowledged_count: "Confirmados",
  metric_total: "Total",
  metric_active: "Activos",
  metric_online: "En línea",
  metric_offline: "Fuera de línea",
  metric_ota_pending: "OTA pendiente",
  metric_battery_warn: "Batería baja",
  metric_doors_open: "Puertas abiertas",
  metric_windows_open: "Ventanas abiertas",
  metric_signal_avg: "Señal media",
  metric_last_comm: "Última com.",
  metric_packets: "Paquetes / h",
  view_all: "Ver todo",
  status_new: "Nuevo",
  status_acknowledged: "Confirmado",
  status_resolved: "Resuelto",
  status_resolved_local: "Resuelta (local)",
  resolve: "Resolver",
  add_note: "Añadir nota",
  save_note: "Guardar nota",
  resolve_local_badge: "solo este dispositivo",
  resolve_local_hint: "Marca la alerta como resuelta solo en tu navegador. El servidor y otros miembros del equipo la siguen viendo como abierta.",
  note_placeholder: "Añade contexto para el equipo…",
  notes_count: "{n} nota(s)",
  device_detail: "Detalle del dispositivo",
  device_diagnostics: "Diagnóstico",
  device_firmware_history: "Historial de firmware",
  device_ota_config: "Configuración OTA",
  device_ota_status: "Estado OTA",
  device_signal: "Calidad de señal",
  device_mac: "Dirección MAC",
  device_serial: "Número de serie",
  fall_sensitivity: "Sensibilidad de caída",
  transmission_interval: "Intervalo de transmisión",
  low_battery_threshold: "Umbral de batería baja",
  ota_idle: "Inactivo",
  ota_pending: "Pendiente",
  ota_deploying: "Desplegando",
  ota_failed: "Fallido",
  events_filter_severity: "Gravedad",
  events_filter_room: "Habitación",
  events_filter_patient: "Paciente",
  events_filter_device: "Dispositivo",
  severity_info: "Info",
  severity_warning: "Advertencia",
  severity_critical: "Crítico",
  telegram_title: "Alertas de Telegram",
  telegram_desc: "Recibe alertas de Telegram para los residentes que tienes asignados.",
  telegram_connect: "Conectar Telegram",
  telegram_connected: "Telegram conectado",
  telegram_connected_as: "Conectado a Telegram como {name}",
  telegram_connect_success: "Telegram conectado correctamente",
  telegram_connect_error: "No se pudo conectar Telegram. Inténtalo de nuevo.",
  telegram_missing_bot: "Bot de Telegram no configurado. Define REACT_APP_TELEGRAM_BOT en el archivo env.",
  telegram_disconnect: "Desconectar",
  telegram_disconnect_success: "Telegram desconectado.",
  telegram_disconnect_error: "No se pudo desconectar Telegram. Inténtalo de nuevo.",
  telegram_already_linked: "Esta cuenta de Telegram ya está vinculada a otro usuario de e2-care.",
  telegram_switch_q: "¿Usar otra cuenta de Telegram?",
  telegram_switch_intro: "Telegram recuerda qué cuenta está conectada en todos los sitios web. Para usar otra:",
  telegram_switch_step1: "Abre Telegram Web y cierra la sesión de tu cuenta actual.",
  telegram_switch_step2: "Vuelve aquí y recarga el botón de abajo, luego inicia sesión con la otra cuenta.",
  telegram_open_web: "Abrir Telegram Web",
  telegram_reload_widget: "Cerré sesión — recargar el botón",
  lang_autodetected_toast: "Idioma detectado: {language}. Puedes cambiarlo en Ajustes.",
  admin_view_active: "Activos",
  admin_view_archived: "Archivados",
  admin_restore: "Restaurar",
  admin_restored: "Restaurado.",
  admin_hard_delete: "Eliminar definitivamente",
  admin_hard_delete_title: "¿Eliminar definitivamente?",
  admin_hard_delete_confirm: "«{name}» se eliminará definitivamente de la base de datos. Esta acción no se puede deshacer.",
  admin_hard_deleted: "Eliminado definitivamente.",
  admin_no_archived: "No hay elementos archivados.",
  language_desc: "Se usa para la interfaz de la aplicación y tus notificaciones de Telegram + push.",
  language_saved: "Idioma actualizado.",
  language_error: "No se pudo actualizar el idioma. Inténtalo de nuevo.",
  admin_field_language: "Idioma",
  edit: "Editar",
  generic_error: "Algo salió mal. Inténtalo de nuevo.",
  caregiver_added: "Cuidador añadido.",
  caregiver_removed: "Cuidador eliminado.",
  family_added: "Familiar añadido.",
  family_removed: "Familiar eliminado.",
  menu: "Menú",
  dl_companion_app: "Aplicación complementaria",
  dl_hero_title: "E2 Care para Android",
  dl_hero_sub: "Instala la aplicación complementaria en un teléfono con Moko para retransmitir alertas, configurar dispositivos y mantenerte conectado con tu equipo de cuidado, incluso cuando el panel está cerrado.",
  dl_android_apk: "APK de Android",
  dl_version_loading: "cargando versión…",
  dl_released: "Publicado el {date}",
  dl_download_apk: "Descargar APK",
  dl_unavailable: "No disponible",
  dl_preparing: "Preparando…",
  dl_manifest_error: "No se pudo cargar el manifiesto. Intenta actualizar; si el problema persiste, el servidor de compilación puede estar redesplegándose.",
  dl_whats_new: "Novedades",
  dl_installing_title: "Instalación en tu teléfono",
  dl_step1: "Toca «Descargar APK» arriba. Tu navegador puede advertir que los archivos APK pueden dañar tu dispositivo; esa advertencia es normal para cualquier instalador descargado fuera de Play Store.",
  dl_step2: "Abre el archivo descargado. Android te pedirá permitir instalaciones desde este navegador la primera vez; activa el permiso y vuelve.",
  dl_step3: "Toca «Instalar» y luego «Abrir» cuando termine.",
  dl_step4: "Inicia sesión con tus credenciales de E2 Care.",
  dl_iphone_note: "La versión para iPhone llegará más adelante. Por ahora, usa el panel web.",
  dl_back_to_dashboard: "Volver al panel",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Cambiar de organización borra la asignación actual de habitación y paciente.",
  admin_view_full: "Lista completa",
  device_filter_assignment: "Asignación",
  device_filter_patient: "Asignado a paciente",
  device_filter_room: "Asignado a habitación",
  device_filter_unassigned: "Sin asignar",
  admin_all_orgs: "Todas las organizaciones",
  pagination_prev: "Anterior",
  pagination_next: "Siguiente",
  pagination_per_page: "Por página",
  pagination_page_of: "Página {page} de {pages}",
  pagination_total: "{total} en total",
  event_charging: "Carga iniciada",
  event_sos_cancel: "SOS cancelado",
  event_call: "Llamada SOS",
  device_personal_alarm: "Alarma personal",
  device_charging: "Cargando",
  device_location: "Ubicación",
  device_current_location: "Ubicación actual",
  device_no_location: "Aún no se ha reportado ubicación.",
  device_location_source: "Fuente",
  device_location_updated: "Actualizado",
  device_track_1h: "1h",
  device_track_24h: "24h",
  device_track_7d: "7d",
  device_track_last: "Última posición",
  device_located: "Localizado",
  map_sos: "Alerta SOS",
  map_fall: "Caída detectada",
  map_current: "Posición actual",
  alert_timeline: "Cronología de la alerta",
  alert_trigger: "Disparador",
  alert_calls: "Llamadas",
  alert_view_timeline: "Ver cronología",
  alert_no_deliveries: "Aún no se han enviado notificaciones.",
  alert_cancelled_on_device: "El SOS se canceló en el dispositivo; la alerta permanece abierta hasta que un cuidador la resuelva.",
  call_answered: "Contestada",
  call_missed: "Perdida",
  reopen: "Reabrir",
  reopened: "Alerta reabierta",
  live: "En directo",
  nav_home: "Inicio",
  family_home_kicker: "Vista de familia",
  family_home_title: "Tus seres queridos",
  family_greeting: "Hola",
  family_home_sub: "Un resumen tranquilo de cómo está cada uno.",
  family_status_ok: "está bien",
  family_status_attention: "necesita atención",
  family_all_calm: "Todo en calma ahora mismo.",
  family_attention_sub: "Vamos a ver cómo está — detalles abajo.",
  family_last_seen: "visto por última vez",
  family_latest_alert: "Última alerta",
  family_no_alerts: "Sin alertas recientes: todo va bien.",
  family_view_details: "Ver detalles",
  family_no_device: "Aún no hay alarma personal vinculada.",
  status_never_reported: "Nunca reportó",
  mv_title: "Movimiento",
  mv_sub: "De {n} sensor(es) de movimiento · ventanas de 5 minutos",
  mvo_title: "Movimiento de un vistazo",
  mvs_moving: "{name} está en pie y en movimiento",
  mvs_moving_sub: "Se movió {when}",
  mvs_rest: "{name} está descansando",
  mvs_rest_sub: "Último movimiento {when}",
  mvs_rest_sub_none: "Sin movimiento en los últimos 30 días",
  mvs_quiet: "{name} lleva más tiempo sin moverse de lo habitual",
  mvs_quiet_sub: "Sin movimiento desde hace {dur}. Quizá valga la pena llamar.",
  mvs_short_quiet: "Quieto mucho rato",
  mvs_room_moving: "Alguien se mueve en {name}",
  mvs_room_rest: "{name} está en calma",
  mvs_room_quiet: "Sin movimiento en {name} durante más tiempo de lo habitual",
  mvs_sensor: "El sensor de movimiento no envía datos",
  mvs_sensor_sub: "Esto es del sensor, no de {name}. Última señal {when}.",
  mvs_nodata: "Aún no hay datos de movimiento",
  mvs_nodata_sub: "El sensor de movimiento aún no ha enviado nada.",
  mvd_title: "Últimas 24 horas",
  mvd_moving: "En movimiento",
  mvd_resting: "En reposo",
  mvd_nosignal: "Sin señal",
  mvd_night: "Noche",
  mvd_now: "Ahora",
  mvn_title: "Últimas 7 noches",
  mvn_last_night: "Anoche",
  mvn_last_short: "Anoche",
  mvn_calm: "Tranquila",
  mvn_restless: "Inquieta",
  mvn_still: "Muy quieta",
  mvn_silent: "Sensor callado",
  mvn_nodata: "Sin datos",
  mvn_s_calm_none: "Noche tranquila, sin movimiento entre {from} y {to}.",
  mvn_s_calm_once: "Noche tranquila, se levantó una vez hacia las {at}.",
  mvn_s_calm_many: "Noche tranquila, se levantó {n} veces, primero hacia las {first}, la última hacia las {last}.",
  mvn_s_restless: "Noche inquieta, se levantó {n} veces entre {first} y {last}.",
  mvn_s_still: "Noche muy quieta, menos movimiento de lo habitual. Descanso más largo {dur}.",
  mvn_s_still_moved: "Noche muy quieta, solo se movió hacia las {at}. Descanso más largo {dur}.",
  mvn_s_silent: "El sensor estuvo casi callado, así que no sabemos cómo fue la noche.",
  mvn_s_nodata: "Sin datos de movimiento para esta noche.",
  mv_state_moving: "En movimiento",
  mv_state_still: "En reposo",
  mv_state_inactive: "Inactivo",
  mv_state_silent: "Sensor sin reportar",
  mv_state_never: "Nunca reportó",
  mv_state_nodata: "Aún sin datos",
  mv_state_no_sensor: "Sin sensor de movimiento",
  mv_last_movement: "Último movimiento",
  mv_last_sample: "Última señal del sensor",
  mv_none_in_retention: "Ninguno en los últimos 30 días",
  mv_silent_hint: "Sin muestras desde hace más de {min} min: revise el sensor o su gateway. Es un fallo del dispositivo, no inmovilidad.",
  mv_inactive_hint: "Sin movimiento desde hace más de {min} min mientras el sensor sigue reportando.",
  mv_history: "Historial de movimiento",
  mv_history_empty: "Aún no hay datos de movimiento en este periodo.",
  mv_not_reporting: "Sin reportar",
  mv_no_movement: "Sin movimiento",
  mv_detections: "detecciones de movimiento",
  mv_legend_motion: "Detecciones de movimiento",
  mv_legend_gap: "Sin reportar",
  mv_retention_note: "Historial conservado 30 días",
  mv_strip_title: "Movimiento en directo",
  mv_strip_sub: "{n} sensor(es) de movimiento",
  mv_unassigned: "Sensor sin asignar",
  admin_alerts_timezone: "Zona horaria de la organización",
  admin_alerts_timezone_invalid: "Elija una zona horaria IANA válida.",
  admin_alerts_night_wrap_hint: "El horario nocturno va de {start} a {end} de la mañana siguiente ({tz}), es decir, después de {start} o antes de {end}.",
  admin_alerts_night_same_day_hint: "El horario nocturno va de {start} a {end} el mismo día ({tz}).",
  admin_alerts_night_equal: "El inicio y el fin no pueden ser la misma hora.",
  admin_alerts_inactivity_label: "Umbral de inactividad",
  admin_alerts_inactivity_question: "¿Se ha movido esta persona? Minutos sin movimiento antes de que sea motivo de alerta.",
  admin_alerts_silence_label: "Umbral de silencio del dispositivo",
  admin_alerts_silence_question: "¿Sigue comunicando este sensor? Minutos sin ninguna muestra antes de considerarlo un fallo del dispositivo y no un residente inactivo.",
  admin_alerts_minutes: "minutos",
  admin_alerts_threshold_invalid: "Introduzca un número entero mayor que 0.",
  admin_alerts_thresholds_provisional: "Los valores iniciales (180 / 30 min) aún no se han ajustado: adáptelos a sus residentes.",
  admin_tab_gateways: "Gateways",
  gw_title: "Gateways",
  gw_status_deactivated: "Desactivada",
  gw_scope_pending: "Las pasarelas de su organización aparecerán aquí cuando la actualización del backend esté activa.",
  gw_none_for_org: "Aún no hay ninguna pasarela asignada a esta organización.",
  gw_col_room: "Habitación",
  gw_unassigned: "Sin asignar",
  gw_never: "Nunca",
  gw_edit_title: "Editar pasarela",
  gw_new_title: "Nueva pasarela",
  gw_super_field: "Solo un superadministrador puede cambiar esto",
  gw_mac_invalid: "Introduzca 12 caracteres hexadecimales, p. ej. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Tipo de hardware",
  gw_notes: "Notas",
  gw_manage_sub: "Hubs BLE que retransmiten los sensores: estado, organización y habitación. Una pasarela muda hace que todos sus sensores parezcan mudos.",
  gw_filter_all: "Todas las organizaciones",
  gw_new: "Nueva pasarela",
  gw_col_assignment: "Organización · Habitación",
  gw_backend_pending: "Esto requiere la actualización del backend, aún no desplegada.",
  gw_save_failed: "Guardar pasarela",
  gw_created: "Pasarela creada",
  gw_saved: "Pasarela guardada",
  gw_reactivated: "Pasarela reactivada",
  gw_deactivated: "Pasarela desactivada",
  gw_reactivate: "Reactivar",
  gw_deactivate: "Desactivar",
  gw_reactivate_title: "¿Reactivar {name}?",
  gw_deactivate_title: "¿Desactivar {name}?",
  gw_reactivate_desc: "Volverá a contar en el estado y las alertas.",
  gw_deactivate_desc: "Deja de contar en el estado y las alertas. Se conserva su historial y puede reactivarla cuando quiera.",
  gw_heard_title: "Dispositivos que oye",
  gw_heard_sub: "Sensores retransmitidos por esta pasarela en las últimas 24 horas.",
  gw_heard_none: "Ningún dispositivo en las últimas 24 horas.",
  gw_heard_unknown: "Dispositivos desconocidos",
  gw_msgs_short: "msj",
  gw_avg: "media",
  gw_samples_short: "muestras",
  gw_not_found: "Pasarela no encontrada o no visible para usted.",
  gw_one: "Pasarela",
  gw_manage_link: "Gestionar en Administración",
  gw_rssi_range: "Rango de señal",
  gw_longest_gap: "Corte más largo",
  gw_config_push: "Último envío de config.",
  gw_sub: "Concentradores BLE que transmiten los datos de los sensores. Solo lectura: un gateway en silencio hace que todos sus sensores parezcan en silencio.",
  gw_super_only: "El estado de los gateways solo está disponible para superadministradores.",
  gw_load_failed: "Cargar gateways",
  gw_status_reporting: "Reportando",
  gw_status_silent: "En silencio",
  gw_status_never_seen: "Nunca visto",
  gw_returned: "Volvió tras {h} h de ausencia (terminó {at})",
  gw_count_reporting: "{n} reportando",
  gw_count_silent: "{n} en silencio",
  gw_count_never: "{n} nunca vistos",
  gw_count_deactivated: "{n} desactivada(s)",
  gw_window: "Obsoleto tras {h} h sin mensajes",
  gw_col_name: "Gateway",
  gw_col_status: "Estado",
  gw_col_msgs: "Mensajes 24 h",
  gw_col_discard: "Descartados",
  gw_last_message: "Último mensaje",
  gw_devices_seen: "Dispositivos vistos",
  gw_hours_active: "Horas activas",
  gw_unregistered_title: "Reportando sin registro",
  gw_unregistered_desc: "Estos identificadores aparecen en la actividad de gateways pero no tienen registro (p. ej. una unidad que reporta con un IMEI). Es normal que los totales de ambas fuentes difieran.",
  nav_reports: "Informes",
  rep_night_title: "Resumen nocturno",
  rep_night_desc: "Resumen matinal del movimiento de cada residente durante el horario nocturno de la organización y de los silencios de los sensores.",
  rep_last_night: "Anoche",
  rep_nights_ago: "Hace {n} noches",
  rep_policy_fallback: "horario nocturno por defecto (política no disponible)",
  rep_movement: "Movimiento",
  rep_windows: "{n} ventanas de 5 min activas",
  rep_no_movement: "Sin movimiento",
  rep_first_movement: "Primer movimiento",
  rep_longest_still: "Mayor periodo inmóvil",
  rep_silences: "Silencios del sensor",
  rep_none: "Ninguno",
  rep_coverage: "{pct}% reportado",
  rep_night_note: "Las horas están en la zona horaria de la organización. La inmovilidad solo se cuenta mientras el sensor reporta; los silencios iguales o superiores al umbral de silencio se listan aparte.",
  dh_reporting_title: "Estado de reporte",
  dh_never_reported_desc: "Registrado pero nunca ha reportado. Es una instalación pendiente, no un dispositivo desconectado.",
  dh_interval_still: "Intervalo medido (en reposo)",
  dh_interval_moving: "Intervalo medido (en movimiento)",
  dh_interval_samples: "Muestras de medición",
  dh_interval_unmeasured: "Aún no hay intervalo medido: se aplica el umbral de silencio de la organización.",
  dh_interval_note: "Los intervalos se miden a partir de los mensajes recibidos, no del valor configurado.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Habitación compartida: puede incluir el movimiento de otros",
  rep_no_data_night: "Sin datos para esta noche: el sensor no reportaba (o aún no estaba instalado).",
  nav_buildings: "Edificios",
  imei_label: "IMEI",
  imei_hint: "15 dígitos, impresos en la parte trasera del dispositivo",
  imei_length: "El IMEI tiene 15 dígitos",
  imei_invalid: "Este IMEI no es válido. Revise los dígitos",
  imei_resident_note: "La alarma acompaña al residente, por lo que no se asigna a una habitación.",
  imei_online_hint: "El dispositivo aparece en línea tras su primera señal de vida, unos 5 minutos después de encenderlo.",
  forgot_link: "¿Olvidó su contraseña? Haga clic aquí",
  forgot_title: "Restablecer su contraseña",
  forgot_sub: "Introduzca su correo y le enviaremos un enlace para restablecer la contraseña.",
  forgot_submit: "Enviar enlace",
  forgot_sent: "Si existe una cuenta con este correo, hemos enviado un enlace para restablecer la contraseña. Revise su bandeja de entrada.",
  forgot_back: "← Volver a iniciar sesión",
  reset_title: "Nueva contraseña",
  reset_sub: "Elija una nueva contraseña para su cuenta.",
  reset_new_password: "Nueva contraseña",
  reset_confirm_password: "Confirmar contraseña",
  reset_hint: "Al menos 8 caracteres.",
  reset_submit: "Actualizar contraseña",
  reset_success: "Contraseña actualizada. Redirigiendo al inicio de sesión…",
  reset_too_short: "La contraseña debe tener al menos 8 caracteres.",
  reset_mismatch: "Las contraseñas no coinciden.",
  reset_no_token: "Este enlace no es válido o falta. Solicite uno nuevo desde la página de inicio de sesión.",
  reset_failed: "Este enlace no es válido o ha caducado. Solicite uno nuevo.",
  admin_tab_device_types: "Tipos de dispositivo",
  admin_dt_title: "Tipos de dispositivo",
  admin_dt_sub: "El catálogo de modelos. Cambie la etiqueta visible de un tipo: la clave interna, la asignación IoT y la sincronización no cambian.",
  admin_dt_col_label: "Etiqueta visible",
  admin_dt_col_key: "Clave interna",
  admin_dt_col_category: "Categoría",
  admin_dt_col_wearable: "Portátil",
  admin_dt_col_ble_sync: "Sincronización BLE",
  admin_dt_col_ble_type_id: "ID de tipo BLE",
  admin_dt_wearable_yes: "Lo lleva el residente",
  admin_dt_wearable_no: "Fijo",
  admin_dt_ble_sync_on: "Obligatoria",
  admin_dt_ble_sync_off: "Desactivada",
  admin_dt_edit_label: "Editar etiqueta",
  admin_dt_edit_title: "Cambiar etiqueta",
  admin_dt_edit_desc: "Solo cambia la etiqueta legible. Dispositivos, filtros e integraciones siguen usando la clave interna «{key}».",
  admin_dt_label_saved: "Etiqueta actualizada.",
  admin_dt_label_required: "La etiqueta no puede estar vacía.",
  admin_dt_load_failed: "Cargar tipos de dispositivo",
  admin_dt_save_failed: "Actualizar etiqueta",
  admin_dt_readonly_hint: "Solo los superadministradores pueden cambiar las etiquetas.",
  sensor_climate: "Clima",
  sensor_temperature: "Temperatura",
  sensor_humidity: "Humedad",
  sensor_last_reading: "Última lectura",
  sensor_history_title: "Temperatura y humedad (48 h)",
  sensor_history_empty_title: "Aún no hay lecturas",
  sensor_history_empty_sub: "Asigne un sensor H4 Pro a esta habitación para ver el historial climático.",
  admin_thresholds_title: "Umbrales de sensores",
  admin_thresholds_desc: "Límites de alerta de temperatura y humedad para los sensores H4 Pro de esta organización.",
  admin_thresholds_temp_min: "Temperatura mín.",
  admin_thresholds_temp_max: "Temperatura máx.",
  admin_thresholds_hum_min: "Humedad mín.",
  admin_thresholds_hum_max: "Humedad máx.",
  admin_thresholds_temp_invalid: "La temperatura mínima debe ser menor que la máxima.",
  admin_thresholds_hum_invalid: "La humedad mínima debe ser menor que la máxima.",
  admin_thresholds_hint: "Los cuatro son opcionales: deje un campo vacío para no alertar en ese límite.",
  admin_thresholds_cooldown: "Intervalo entre alertas",
  admin_thresholds_cooldown_placeholder: "Por defecto: 30 min",
  admin_thresholds_cooldown_help: "Minutos entre alertas repetidas de sensor. Déjelo vacío para el valor del sistema (30 min).",
  admin_thresholds_cooldown_invalid: "El intervalo debe ser un número entero de al menos 1 minuto.",
  admin_thresholds_saved: "Umbrales guardados.",
  admin_thresholds_load_failed: "Cargar umbrales",
  admin_thresholds_save_failed: "Guardar umbrales",
  room_activity_view_all: "Ver todos los eventos",
  role_super_admin: "Superadministrador",
  assign_device: "Asignar dispositivo",
  select_device: "Seleccione un dispositivo…",
  admin_patient_no_devices_assigned: "No hay dispositivos asignados.",
  admin_patient_no_wearables: "No hay dispositivos portátiles disponibles en esta organización.",
  admin_patient_device_reassign: "reasignar",
  recent_critical_alerts_title: "Alertas críticas recientes",
  rooms_building_clear: "Quitar filtro",
  buildings_title: "Edificios",
  buildings_sub: "Cada edificio que supervisa, con sus habitaciones, residentes y dispositivos.",
  buildings_view_rooms: "Ver habitaciones",
  wt_title: "Tendencia semanal",
  wt_desc: "Siete noches juntas por residente —o por habitación compartida— para detectar noches inquietas o inusualmente quietas.",
  wt_baseline_note: "cada noche se compara con la mediana de 7 noches de la fila",
  wt_no_sensors: "Ningún residente tiene aún sensor de movimiento.",
  wt_flag_restless: "Inquieta",
  wt_flag_still: "Inusualmente quieta",
  wt_flag_nodata: "Sin datos",
  wt_flag_silent: "Sensor casi sin datos",
  rep_sensor_silent: "El sensor solo informó durante el {pct} % de esta noche. Los huecos indican que el sensor dejó de informar, no que el residente estuviera quieto.",
  wt_legend_active: "Ventanas de 5 min activas",
  wt_legend_still: "Mayor periodo inmóvil (h)",
  fap_title: "Los familiares pueden gestionar alertas",
  fap_desc: "Si está activado, los familiares pueden reconocer, resolver, reabrir y anotar las alertas de sus propios residentes en {org}.",
  note_saved: "Nota guardada",
  event_device_silent: "Sensor sin señal",
  event_no_movement: "Sin movimiento",
  event_no_rise: "Sin movimiento tras la noche",

  dur_lt_min: "menos de un minuto",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Caída detectada",
  am_sos: "Botón SOS pulsado",
  am_low_battery: "Batería del dispositivo baja",
  am_low_battery_dev: "Batería baja en {device}",
  am_door: "Puerta abierta",
  am_door_in: "Puerta abierta en {place}",
  am_door_in_detail: "Puerta abierta en {place} ({detail})",
  am_window: "Ventana abierta",
  am_window_in: "Ventana abierta en {place}",
  am_window_in_detail: "Ventana abierta en {place} ({detail})",
  am_silent: "El sensor de movimiento de {place} dejó de informar hace unos {dur}: revise su alimentación o su gateway",
  am_silent_nodur: "El sensor de movimiento de {place} dejó de informar: revise su alimentación o su gateway",
  am_nomove: "No se detecta movimiento en {place} desde hace unos {dur}",
  am_nomove_nodur: "No se detecta movimiento en {place}",
  am_norise: "No se detecta movimiento en {place} desde que terminó la noche (normalmente levantado a las {time})",
  am_norise_notime: "No se detecta movimiento en {place} desde que terminó la noche",
  amf_silent_res: "El sensor de movimiento de {name} no informa desde las {time}, así que ahora mismo no se sigue el movimiento.",
  amf_silent_room: "El sensor de movimiento de {place} no informa desde las {time}, así que ahora mismo no se sigue el movimiento allí.",
  amf_sensor_ok: "El sensor funciona; simplemente no ha visto a nadie moverse.",
  amf_team: "El equipo de cuidado ha sido avisado en su panel.",
  amf_contact_device: "Usted figura como contacto de este dispositivo.",
  amf_contact_resident: "Usted figura como contacto de {name}.",
  al_tab_care: "Cuidado",
  al_tab_maint: "Mantenimiento",
  al_maint_hint: "Sensores que dejaron de informar y baterías bajas: trabajo técnico, no eventos de cuidado.",
  al_maint_empty: "Ningún problema de sensores o baterías.",
  al_auto_closed: "Cerrada automáticamente",
  al_auto_closed_reason: "Cerrada automáticamente — {reason}",
  al_never_seen: "nadie la vio antes de cerrarse",
  al_resolved_by: "Resuelta por {name}",
  al_reason_movement: "se reanudó el movimiento",
  al_reason_sensor: "el sensor vuelve a informar",
  al_admin_only_ack: "Solo un administrador puede gestionar esta alerta, porque no está vinculada a un único residente.",
  why_title: "¿Por qué saltó esta alerta?",
  why_since_motion: "Desde el último movimiento",
  why_since_sample: "Desde el último informe del sensor",
  why_threshold: "Umbral",
  why_up_by: "Normalmente levantado a las",
  why_night: "Franja nocturna",
  why_source: "Umbral definido por",
  why_src_org: "esta organización",
  why_src_default: "valores por defecto",
  why_state: "Estado del sensor",
  why_checked: "Comprobado a las",
  why_approx: "Las comprobaciones se hacen cada 5 minutos, así que las horas de alerta son aproximadas.",
  mon_label: "Seguimiento del movimiento",
  mon_active: "activo",
  mon_down: "sin informar",
  mon_down_since: "sin informar desde las {time}",
  admin_alerts_up_by_label: "Normalmente levantado a las",
  admin_alerts_up_by_question: "Si no se ve movimiento entre el final de la noche y esta hora, se crea una alerta de «sin movimiento desde que terminó la noche».",
  admin_alerts_up_by_invalid: "Debe ser posterior al final de la noche ({end}): es la hora a la que los residentes suelen estar levantados, una vez terminada la noche.",
  admin_alerts_up_by_format: "Introduzca una hora como HH:MM.",
  admin_alerts_escalation_label: "Avisar a la familia de un sensor sin señal tras",
  admin_alerts_escalation_question: "El personal ve un sensor sin señal enseguida. La familia solo recibe aviso si sigue sin resolverse tras este tiempo (inmediatamente si la organización no tiene cuidadores).",
  admin_alerts_cooldown_note: "Cuando una alerta se cierra, la misma alerta puede volver cuando su umbral se supere de nuevo. La alerta de la mañana salta como mucho una vez al día.",
  admin_alerts_stored_invalid: "La hora de levantarse guardada ({up}) no es posterior al final de la noche ({end}), así que las alertas de la mañana no pueden funcionar y esta política no se puede guardar hasta corregirlo.",
  admin_alerts_defaults_badge: "Valores por defecto",

  fap_auto_on: "Automático: activado, porque esta organización no tiene cuidadores.",
  fap_auto_off: "Automático: desactivado, porque esta organización tiene cuidadores.",
  fap_manual: "Definido por un administrador.",
  fap_reset: "Volver a automático",
  fap_saved: "Guardado",
  fap_save_failed: "No se pudo guardar. Inténtelo de nuevo.",
  fap_pending: "Próximamente",
  fap_retry: "Reintentar",
  recap_title: "Resumen matinal de la noche",
  recap_desc_staff: "Cada día a las 07:00 (hora de la organización), un resumen de la noche de cada residente de su organización.",
  recap_desc_family: "Cada día a las 07:00 (hora de la organización), un resumen de la noche de sus seres queridos.",
  recap_on: "Activado",
  recap_off: "Desactivado",
  recap_email: "Correo",
  recap_telegram_link_first: "Conecte Telegram arriba para recibirlo allí.",
  recap_no_channel: "Elija al menos un canal o no se enviará nada.",
  recap_last_sent: "Último envío {at}",
  recap_saved: "Preferencias guardadas.",
  recap_save_failed: "No se pudieron guardar las preferencias.",
  recap_unavailable: "Próximamente",
  topbar_org_label: "Organización",
  device_ota_phase2: "El despliegue OTA será interactivo en la fase 2.",
  event_window_open: "Ventana abierta",
  event_window_close: "Ventana cerrada",
  event_alarm_end: "Fin de alarma",
  wt_h: "h",
  wt_load_failed: "No se pudo cargar el historial de movimiento. Inténtelo más tarde.",
  recap_load_failed: "No se pudieron cargar las preferencias: toque para reintentar.",
  mv_shared_note: "Este residente comparte habitación. Un sensor de habitación no distingue a los residentes, así que el movimiento se muestra para la habitación, no para una persona.",
  mv_shared_link: "Ver el movimiento de {room}",
  mv_room_shared_note: "Compartida por {n} residentes: este movimiento no puede atribuirse a ninguno de ellos.",
  rep_shared_room_row: "Habitación compartida · {names}",
  admin_motion_resident: "Sensor de cabecera de un residente",
  admin_motion_resident_hint: "Opcional. Elija un residente solo si este sensor vigila su espacio personal (p. ej. orientado a su cama). Sus gráficos de movimiento lo usarán, incluso en una habitación compartida.",
  admin_motion_whole_room: "Toda la habitación",
};
export default es;
